export default __webpack_public_path__ + "static/media/columns-gap.326778bb.svg";